<template>
  <basic-container>
    <Search />
    <Table />
  </basic-container>
</template>

<script>
import { getChannelList } from '@/api/security/channelManage';
import { observable } from "vue";
import Search from './components/search.vue';
import Table from './components/table.vue';

export default {
  name: 'WebSaaSIndex',
  components: {
    Search,
    Table
  },

  provide() {
    return {
      /** 搜索参数 */
      searchParams: this.searchParams,
      /** 列表数据 */
      list: this.list,
      /** 分页的方法 */
      loadList: this.loadList,
    };
  },
  created() {
    this.loadList();
  },
  data() {
    return {
      searchParams: observable({
        /** 渠道id/渠道名称 */
        search: '',
        /** 标签 */
        label: '',
        current: 1,
        size: 10,
        total: 1,
      }),
      list: observable({
        value: [],
        loading: false
      })
    };
  },


  methods: {
    //^ ^--------------分页相关-------------^ ^
    async loadList() {
      this.list.loading = true;
      try {
        const { data: { data: { records, total } } } = await getChannelList(this.searchParams);
        // 更新列表数据
        this.list.value = records;
        this.searchParams.total = total;
      } catch (error) {
        // 提供详细的错误提示信息
        console.error("加载渠道列表失败:", error);
      } finally {
        // 无论请求成功或失败，都关闭loading状态
        this.list.loading = false;
      }
    }

  },
};
</script>

<style lang="scss" scoped></style>
